var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-email-container"},[_c('div',{staticClass:"confirm-email-message"},[_vm._v(" Thanks , you will be notified soon about Account activation. "),_c('br'),_c('button',{staticClass:"refresh-btn",on:{"click":_vm.logOut}},[_vm._v(" Ok ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }